var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2390_12811)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2390_12811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2390_12811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8 0H0.800049V48H48.8V0Z",
    fill: "url(#paint0_linear_2390_12811)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M48.8 0H0.800049V47.9H48.8V0Z",
    fill: "url(#paint1_linear_2390_12811)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M43.9 0H5.40002V47.9H43.9V0Z",
    fill: "url(#paint2_linear_2390_12811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3001 0H11.1001V48H38.3001V0Z",
    fill: "url(#paint3_linear_2390_12811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3001 0H16.2001V48H33.3001V0Z",
    fill: "url(#paint4_linear_2390_12811)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2390_12811)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.3 44C35.0696 44 43.8 35.2696 43.8 24.5C43.8 13.7304 35.0696 5 24.3 5C13.5305 5 4.80005 13.7304 4.80005 24.5C4.80005 35.2696 13.5305 44 24.3 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.5062 27.1489C41.9578 18.2058 35.8848 9.77907 26.9416 8.32739C17.9984 6.87571 9.57176 12.9488 8.12008 21.8919C6.6684 30.8351 12.7414 39.2618 21.6846 40.7135C30.6278 42.1651 39.0545 36.0921 40.5062 27.1489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2734 23.0918C37.5614 25.2342 37.2935 27.4147 36.4956 29.4238C35.6977 31.4329 34.3966 33.203 32.7172 34.5642C29.3743 37.3138 24.5834 38.4562 20.4257 37.0703C18.0873 36.2771 16.048 34.7868 14.5819 32.7999C13.1159 30.813 12.2935 28.4248 12.2254 25.9566C12.1871 24.344 12.5333 22.7454 13.2355 21.2933C13.9378 19.8411 14.9757 18.577 16.2635 17.6057C17.4813 16.6816 18.9037 16.0644 20.4104 15.8062C21.9172 15.548 23.4639 15.6565 24.9199 16.1224C28.2983 17.3046 30.7823 21.024 30.034 24.6326C29.7509 26.1155 28.9173 27.4363 27.7005 28.3298C26.9205 28.8944 26.0028 29.2386 25.0439 29.3261C24.6555 29.3541 24.2653 29.3423 23.8794 29.2907C23.6845 29.2907 23.658 29.0427 23.8794 29.0294C27.9264 28.7903 29.9012 24.6017 28.0946 21.1214C26.5095 18.0884 22.9274 17.101 19.8545 18.2345C15.3603 19.8905 13.7353 24.9514 15.4046 29.211C17.0738 33.4705 21.3378 35.742 25.7966 35.4099C28.1199 35.161 30.3285 34.2721 32.1766 32.8423C34.0246 31.4125 35.4396 29.4978 36.2639 27.3115C36.6001 26.3609 36.8317 25.3765 36.9546 24.3758C36.9635 24.1899 36.9856 22.6268 37.2734 23.0918Z",
    fill: "#DE7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3399 25.9082C11.0519 23.7658 11.3198 21.5852 12.1177 19.5762C12.9156 17.5671 14.2167 15.7969 15.8961 14.4358C19.2391 11.6861 24.0299 10.5438 28.1876 11.9297C30.5263 12.7223 32.566 14.2124 34.0321 16.1994C35.4983 18.1865 36.3204 20.575 36.3879 23.0434C36.4273 24.6568 36.0815 26.2564 35.3793 27.7094C34.677 29.1625 33.6385 30.4272 32.3498 31.3987C31.1316 32.322 29.709 32.9385 28.2023 33.1959C26.6956 33.4533 25.149 33.3441 23.6934 32.8776C20.315 31.6953 17.831 27.976 18.5793 24.3673C18.8624 22.8845 19.696 21.5637 20.9128 20.6701C21.6928 20.1055 22.6105 19.7614 23.5694 19.6739C23.9579 19.6472 24.3482 19.6606 24.7339 19.7137C24.9288 19.7359 24.9553 19.9572 24.7339 19.9705C20.6869 20.2096 18.7121 24.3983 20.5231 27.8786C22.1038 30.9116 25.6859 31.899 28.7588 30.7655C33.253 29.1095 34.878 24.0485 33.1866 19.789C31.4952 15.5295 27.2534 13.258 22.7946 13.5901C20.4716 13.84 18.2634 14.7292 16.4155 16.1589C14.5677 17.5885 13.1524 19.5027 12.3273 21.6885C11.9916 22.6392 11.76 23.6235 11.6365 24.6241C11.641 24.8101 11.6188 26.3731 11.3399 25.9082Z",
    fill: "#57A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2319 26.1647L16.1086 26.6208L15.9404 25.6511L16.6488 24.9604L15.6703 24.8187L15.2319 23.9331L14.7936 24.8187L13.8195 24.9604L14.5235 25.6511L14.3596 26.6208L15.2319 26.1647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1151 18.819L32.9874 19.2795L32.8235 18.3054L33.532 17.6147L32.5535 17.473L32.1151 16.5874L31.6768 17.473L30.7026 17.6147L31.4067 18.3054L31.2428 19.2795L32.1151 18.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3501 26.2268L27.3021 26.7493L26.3501 27.2674L25.8321 28.2193L25.3096 27.2674L24.3621 26.7493L25.3096 26.2268L25.8321 25.2793L26.3501 26.2268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0521 13.3732L24.5303 13.6344L24.0521 13.8912L23.7953 14.3694L23.5341 13.8912L23.0603 13.6344L23.5341 13.3732L23.7953 12.8994L24.0521 13.3732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4894 32.8507L29.9676 33.112L29.4894 33.3688L29.2281 33.847L28.9713 33.3688L28.4976 33.112L28.9713 32.8507L29.2281 32.377L29.4894 32.8507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3764 24.2389L32.8502 24.5002L32.3764 24.7614L32.1151 25.2352L31.8539 24.7614L31.3801 24.5002L31.8539 24.2389L32.1151 23.7651L32.3764 24.2389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2885 32.3727L20.7623 32.6339L20.2885 32.8952L20.0317 33.369L19.7704 32.8952L19.2922 32.6339L19.7704 32.3727L20.0317 31.8989L20.2885 32.3727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6406 30.2428L18.1188 30.4996L17.6406 30.7609L17.3838 31.2391L17.1226 30.7609L16.6488 30.4996L17.1226 30.2428L17.3838 29.769L17.6406 30.2428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8184 18.6862L19.2922 18.9474L18.8184 19.2087L18.5572 19.6824L18.3003 19.2087L17.8221 18.9474L18.3003 18.6862L18.5572 18.2124L18.8184 18.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7544 23.2604L29.2282 23.5172L28.7544 23.7785L28.4976 24.2522L28.2364 23.7785L27.7582 23.5172L28.2364 23.2604L28.4976 22.7822L28.7544 23.2604Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2390_12811",
    x1: 5.57655,
    y1: -4.3581,
    x2: 42.718,
    y2: 50.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E006E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2390_12811",
    x1: 24.8,
    y1: 0.1075,
    x2: 24.8,
    y2: 49.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7C00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7C00A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2390_12811",
    x1: 24.6622,
    y1: 0.1075,
    x2: 24.6622,
    y2: 49.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7C00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7C00A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2390_12811",
    x1: 24.6591,
    y1: 0.1075,
    x2: 24.6591,
    y2: 49.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7C00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7C00A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2390_12811",
    x1: 24.7969,
    y1: 0.1075,
    x2: 24.7969,
    y2: 49.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7C00B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7C00A4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2390_12811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.800049)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2390_12811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(4.80005 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolReject);
export default __webpack_public_path__ + "static/media/symbol-reject.34424923aba02b553983dfa8dc7f1589.svg";
export { ForwardRef as ReactComponent };